<template>
  <div class="index-page">
    <img class="banner-img" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/img/seat_search_.png">
    <div class="topbg">
        <div class="f-item">
          <input placeholder="请输入您的姓名" type="text" v-model="name">
        </div>
        <div class="f-item">
          <input placeholder="请输入验证码" type="number" v-model="code">
          <img :src="captcha"  @click="loadCaptcha">
        </div>
        <div class="btn-cont">
          <button @click="searchSeat">查 询</button>
        </div>
    </div>
    <div class="info">
      <h3>- 主办单位 Hosts -</h3>
      <span>国家发展和改革委员会</span>
      <span class="text-sm">National Development and Reform Commission</span>
      <span>上海市人民政府</span>
      <span class="text-sm">Shanghai Municipal People's Government</span>
      <h3>- 承办单位 Organizers -</h3>
      <span>上海市发展和改革委员会</span>
      <span class="text-sm">Shanghai Municipal Development and Reform Commission</span>
      <span>上海市国际贸易促进委员会</span>
      <span class="text-sm">Council For The Promotion Of International Trade Shanghai</span>
    </div>
<!--    弹框-->
    <van-popup v-model="popCard">
      <div class="modal-pop">
        <div class="el-doc">
          <!--观众证-->
          <img  class="doc-img" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/cz-ltjb.png"/>
          <!--主办单位-->
<!--          <image  class="doc-img" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/zbdw.png"/>-->
          <!--展商证-->
<!--          <image  class="doc-img" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/zs.png"/>-->
          <!--工作人员-->
<!--          <image   class="doc-img" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/gzry.png"/>-->
          <!--媒体证-->
<!--          <image  class="doc-img" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/mtz.png"/>-->
          <!--贵宾证-->
<!--          <image   class="doc-img" src="https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/cne/gb.png"/>-->
          <div class="doc-info">
            <span> {{meetingSeatDetail.unitName}}</span>
            <span class="name">{{meetingSeatDetail.name}}</span>
            <span>{{meetingSeatDetail.position}}</span>
            <span style="margin-top: 20px;font-size: 14px">您的座位是</span>
            <span class="text-lg">{{meetingSeatDetail.seat}}</span>
          </div>
          <div class="closed" @click="popCard = false">
            <img src="../assets/closed.png">
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 重名的情况 -->
    <van-popup v-model="popNameList">
        <div class="modal-pop" >
          <div class="name-cont">
            <h3>请选择您的单位信息查看座位号</h3>
            <ul class="name-list">
              <li v-for="item in nameList" :key="item.id" @click="showCard(item)">
                <div class="name">{{item.name}}</div>
                <span>{{item.unitName}}</span>
              </li>
            </ul>
          </div>
        </div>
      </van-popup>
<!--    未查到信息-->
    <van-popup v-model="noInfo">
      <div class="modal-pop no-info">
        <van-icon color="#f60" size="70px" name="warning-o" />
        <p>未查到信息</p>
        <van-button @click="noInfo = false" block color="linear-gradient(to right, #8EC31F, #7AAE09)" size="middle">
          确定
        </van-button>
      </div>
    </van-popup>
<!--    座位信息尚未开放查询-->
    <van-popup v-model="showCommingSoon" :close-on-click-overlay="false" :disable-scroll="true" >
      <div class="modal-pop no-info">
        <h3>主旨论坛已闭幕</h3>
        <div class="tips" >请移步展馆继续参观展会</div>
        <div class="tips" >了解更多信息请关注 <span>“碳中和博览会”</span> </div>
        <div class="tips" >官方公众号和小程序</div>
        <div class="conde-cont">
          <img src="../assets/cneQrCode.jpg">
          <img src="../assets/cnePub.jpeg">
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import axios from "axios";
import data from "../util/data";

export default {
  name: "seat_search",
  data(){
    return{
      popCard: false,
      noInfo: false,
      showCommingSoon:true,
      captcha: "",
      popNameList:false,
      nameList:[],
      currentItem:{},
      code:"",
      name:"",
      codeKey:"",
      cneMiniUrl:"#小程序://碳中和博览会/fQWbZHCdQecGGac",
      meetingSeatDetail:{},
      exhibitId:"1475402927203536898"
    }
  },
  mounted() {
    this.loadCaptcha();
    this.pageBlank();
  },
  methods:{
    /**
     * 页面空白问题
     */
    pageBlank(){
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // 如果是IOS设备
      if (isiOS) {
        let flag = false;
        let pageBackNormFunc;
        // 聚焦后，键盘弹起
        document.body.addEventListener('focusin', () => {
          flag = true;
          pageBackNormFunc && clearTimeout(pageBackNormFunc)
        });
        // 失焦后，键盘关闭
        document.body.addEventListener('focusout', () => {
          if (flag) {
            // 页面滚动回原来的位置
            pageBackNormFunc = setTimeout(() => {
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }, 200);
          }
          flag = false;
        });
      }
    },
    /**
     * 获取验证码
     */
    loadCaptcha() {
      let that = this;
      axios.get( data.captcha)
        .then(function (res) {
          if (res.status == 200) {
            that.captcha = res.data.image
            that.codeKey = res.data.key
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    /**
     * 座位查询
     */
    searchSeat() {
      let that = this;
      this.showCommingSoon =true;
      return;

      if(!that.name){
        this.$toast("请填写姓名");
        return;
      }
      if(!that.code){
        this.$toast("请填写验证码");
        return;
      }
      axios.get( data.searchMeetingSeat+"?tenantId="+data.meetingTenantId+"&name="+that.name+"&code="+that.code+"&codeKey="+that.codeKey)
        .then(function (res) {
          if (res.data.code == 200) {
            if(res.data.data && res.data.data.length>1){
              that.nameList =res.data.data
              that.popNameList=true;
            }else if(res.data.data && res.data.data.length==1){
              that.meetingSeatDetail = res.data.data[0]
              that.popCard = true;
            }else{
              //信息未查到
              that.noInfo = true
              that.loadCaptcha();
              that.code=""
            }
          }else{
            that.$toast(res.data.msg);
            that.loadCaptcha();
            that.code=""
          }
        })
        .catch(function (error) {
          console.log(error);
          that.$toast("查询失败");
        });
    },
    /**
     * 弹出选择
     */
    showCard(item){
      this.meetingSeatDetail=item;
      this.popCard = true
      this.popNameList = false
    }
  }
}
</script>
<style scoped>
.index-page{
  background:#F0F5EB;
  padding-bottom: 20px;

}
.banner-img{
  margin-top: -20px;
}
.name-cont{
  background: #fff;
  border-radius: 10px;
  padding:20px;
  width: 100%;
  position: relative;
  z-index: 99;
}
/deep/.van-popup{
  width: 90%;
  border-radius: 20px;
  overflow: initial;
  background: none;
}
.modal-pop .name-cont h3{
  font-size: 18px;
  color:#333;
  display: block;
  margin-bottom: 16px;
}
.modal-pop .tips{
  font-size: 14px;
  line-height: 1.6;
}
.modal-pop .tips span{
  color:#07801B;
}
.modal-pop h3{
  font-size: 20px;
  margin-bottom:20px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 16px;
  display: block;
  width: 100%;
  text-align: center;
}
.modal-pop .conde-cont{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:20px 0;
}
.modal-pop .conde-cont img{
  flex:1;
  width: 50%;
}
.no-info{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:30px 20px 20px;
  background: #fff;
  border-radius: 20px;
}
.no-info p{
  font-size: 20px;
  margin:10px 20px 30px;
}
.no-info button{
  border-radius: 10px;
}
.name-list li{
  display: flex;
  flex-direction: column;
  background:url("../assets/arrow.png") no-repeat;
  background-size: 6px auto;
  background-position: right center;
  align-items: flex-start;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  line-height: 1.4;
}
.name-list li:last-child{
  border-bottom: 0;
}
.name-list li .name{
  font-size:16px ;
}
.name-list li span{
  color:#999;
  font-size: 14px;
}
.closed{
  position: absolute;
  bottom:-60px;
  left:50%;
  transform: translate(-50%,0);
  z-index: 999;
}
.closed img{
  width: 50px;
  height: 50px;
}
.el-doc .doc-img {
  display: block;
  border-radius: 20px;
  margin-right: -1px;
}
.el-doc {
  position: relative;
  z-index: 9999;
  margin-top: -30px;
}
.text-lg{
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 2px;
}
.el-doc .doc-info {
  position: absolute;
  left: 20px;
  color: #fff;
  top: 50%;
  transform: translate(0, -50%);
  font-size: 12px;
  display: flex;
  line-height: 1.6;
  flex-direction: column;
}
.el-doc .doc-info .name {
  font-size: 22px;
  font-weight: bold;
}

.topbg{
  background: url("https://arbon2022-sh.oss-cn-shanghai.aliyuncs.com/img/seat_search_bg.png") no-repeat center bottom;
  background-size: 100% auto;
  padding:20px 30px 80px;
  margin-top: -20px;
}
.topbg input{
  padding:10px 20px;
  width: 100%;
  height: 50px;
  background: none;
  border:none;
  font-size: 16px;
  color: #fff;
}
.topbg input::placeholder{
  color:rgba(255,255,255,.5);
}
.topbg .f-item{
  display: flex;
  align-items: center;
  background: rgba(0, 24, 52, 0.15);
  border: 0.5px solid rgba(235, 233, 240, 0.2);
  border-radius: 5px;
  margin:10px 0;
  padding-right: 5px;
}
.topbg .f-item img{
  height: 40px;
}
.topbg .btn-cont{
  padding:20px 50px;
}
.topbg .btn-cont button{
  background: linear-gradient(114.91deg, #8EC31F 15.86%, #7AAE09 84.14%);
  border-radius: 10px;
  height: 53px;
  width: 100%;
  border:none;
  color:#fff;
  font-size: 18px;
}
.info{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:16px 0;
  line-height: 1.6;
  box-sizing: border-box;
  flex:1;
}
.info h3{
  font-size: 14px;
  color:#07801B;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom:6px;
}
.info .span{
  color:#666
}
.info .text-sm{
  color:#666;
  transform: scale(.8);
}
</style>



// WEBPACK FOOTER //
// src/page/seatSearch.vue